import RubricQuestion from './RubricQuestion'
export default RubricQuestion
